import { getResourceKey$LoginStatus } from "kreate-server/commands/LoginStatus/fetcher";
import { handler$LoginStatus } from "kreate-server/commands/LoginStatus/handler";
import { GetServerSideProps } from "next";
import { SWRConfig, unstable_serialize } from "swr";
import { z } from "zod";

import PageGalleryCollector$SentOffers from "../../../../containers/PageGalleryCollector$SentOffers";
import { omitUndefinedRecursively } from "../../../../utils";

import { intentionallyIgnoreError } from "@/modules/common-utils/assert";
import { getDb } from "@/modules/mongodb";

type Props = {
  statusCode: 200;
  pageProps: React.ComponentProps<typeof PageGalleryCollector$SentOffers>;
  fallback: Record<string, unknown>;
};

const PageQuery = z.object({
  addressIsh: z.string(),
});

export default function Route({ pageProps, fallback }: Props) {
  return (
    <SWRConfig value={{ fallback }}>
      <PageGalleryCollector$SentOffers {...pageProps} />
    </SWRConfig>
  );
}

export const getServerSideProps: GetServerSideProps<Props> = async (
  context
) => {
  const pageQuerySP = PageQuery.safeParse(context.query);
  if (!pageQuerySP.success) return { notFound: true };
  const { addressIsh } = pageQuerySP.data;

  const db = await getDb();

  const fallback_LoginStatus = await handler$LoginStatus(db, {
    token: context.req.cookies["token"],
  }).catch(intentionallyIgnoreError);

  return {
    props: omitUndefinedRecursively<Props>({
      statusCode: 200,
      pageProps: { addressIsh },
      fallback: {
        [unstable_serialize(getResourceKey$LoginStatus())]:
          fallback_LoginStatus,
      },
    }),
  };
};
